import type { MuiTheme as Theme } from '@paintscout/ui'
import type { CSSProperties } from 'react'

/**
 * Shared visual treatment for "_unavailable_" calendar events — a diagonal
 * stripe pattern with a subtle blur overlay. Used by both DayEvent and
 * WeekEvent so the stripe parameters live in one place.
 */
export function getUnavailableStripeBackground(theme: Theme): CSSProperties['backgroundImage'] {
  return `repeating-linear-gradient(
    135deg,
    ${theme.paintscout.palette.brand.Neutral.P98},
    ${theme.paintscout.palette.brand.Neutral.P98} 10px,
    ${theme.paintscout.palette.brand.Neutral.P94} 10px,
    ${theme.paintscout.palette.brand.Neutral.P94} 12px
  )`
}

export const unavailableBlurOverlay = {
  content: '""',
  position: 'absolute',
  inset: 0,
  pointerEvents: 'none',
  backdropFilter: 'blur(1px)',
  zIndex: 1
} as const
